import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { readToken, removeLocalStorage } from "Utils/Helpers/Token";
const baseURL = process.env.REACT_APP_BACKEND_BASE_URL;
const instance = axios.create({
    baseURL: baseURL,
    timeout: 50000,
});
instance.interceptors.request.use(
    (request) => {
        request.headers = {
            'accept': 'application/json',
            'x-access-token': `${readToken()}`,
            'Content-Type': 'application/x-www-form-urlencoded',
        }
        return request;
    },
    (error) => {
        Promise.reject(error)
    }
)
instance.interceptors.response.use(
    (response) => {
        return {
            code: response.status,
            status: true,
            data: response.data.data
        };
    },
    (error) => {
        try {
            if(error.response.status === 401) {
                removeLocalStorage();
                window.location.replace("/");
            } else if(error.response.status === 403) {
                enqueueSnackbar('شما دسترسی لازم برای انجام این عملیات را ندارید', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 11000) {
                enqueueSnackbar('یکی از مشخصات کلیدی تکراری می‌باشد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 321140) {
                enqueueSnackbar('امکان اضافه کردن نوبت جدید وجود ندارد، سقف نوبت‌ها پر شده است', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 321393) {
                enqueueSnackbar('برای بیمار در این روز نوبت دیگری ثبت شده است', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 45961) {
                enqueueSnackbar('امکان حذف این بیمار وجود ندارد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 46041) {
                enqueueSnackbar('شماره پرونده بیمار تکراری می‌باشد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 12761) {
                enqueueSnackbar('امکان اضافه کردن کاربر جدید نمی‌باشد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 12781) {
                enqueueSnackbar('خطایی در زمان تغییر رمز کاربر بوجود آمده است', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 12801) {
                enqueueSnackbar('امکان حذف این کاربر وجود ندارد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 12821) {
                enqueueSnackbar('عملیات حذف کاربر فعلی غیر مجاز می‌باشد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 12841) {
                enqueueSnackbar('امکان غیر فعال کردن پزشک با نوع فعال وجود ندارد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 12881) {
                enqueueSnackbar('امکان حذف کاربر با نوع ثبت شده وجود ندارد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 12918) {
                enqueueSnackbar('برای انتخاب بیش از یک پزشک حساب خود را به کلینیک ارتقا دهید', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 51390) {
                enqueueSnackbar('امکان اضافه کردن نوع جدید نمی‌باشد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 51410) {
                enqueueSnackbar('امکان حذف این نوع وجود ندارد', {variant: 'error'});
            } else if(error.response.data.data.error.code && error.response.data.data.error.code === 629134) {
                enqueueSnackbar('این دستگاه کارت‌خوان دارای ردیف مالی ثبت شده است', {variant: 'error'});
            } else {
                if(window.location.pathname.includes("/dashboard"))
                enqueueSnackbar('خطایی در زمان اجرای فرمان رخ داده است', {variant: 'error'});
            }
            return {
                code: error.response.status,
                error: error.response.data.data.error.code,
                status: false
            }
        } catch {
            return {
                code: error,
                status: false
            }
        }
    }
)
export default instance;